import * as React from 'react';
export const websiteSvg = React.forwardRef(function websiteSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-7.304 6.463a6.583 6.583 0 0 1-1.392 0 22.01 22.01 0 0 1-.862-3.313h3.116a22.006 22.006 0 0 1-.862 3.313Zm1.476-.335a6.521 6.521 0 0 0 3.515-2.978h-2.81a23.18 23.18 0 0 1-.705 2.978Zm4.061-4.278A6.504 6.504 0 0 0 14.5 8a6.5 6.5 0 0 0-.267-1.85h-3.18c.06.596.097 1.217.097 1.85s-.036 1.254-.097 1.85h3.18Zm-.546-5a6.521 6.521 0 0 0-3.515-2.978 23.55 23.55 0 0 1 .705 2.978h2.81ZM8.696 1.537a22.002 22.002 0 0 1 .862 3.313H6.442a21.999 21.999 0 0 1 .862-3.313 6.575 6.575 0 0 1 1.392 0Zm-2.868.335A6.521 6.521 0 0 0 2.313 4.85h2.81a23.182 23.182 0 0 1 .705-2.978ZM1.768 6.15A6.501 6.501 0 0 0 1.5 8c0 .643.093 1.264.267 1.85h3.18A18.157 18.157 0 0 1 4.85 8c0-.633.036-1.254.097-1.85h-3.18Zm.545 5a6.52 6.52 0 0 0 3.515 2.978 23.635 23.635 0 0 1-.705-2.978h-2.81ZM9.85 8c0 .633-.04 1.254-.105 1.85h-3.49A16.972 16.972 0 0 1 6.15 8c0-.633.04-1.254.105-1.85h3.49c.066.596.105 1.217.105 1.85Z',
    }),
  );
});
websiteSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var website = {
  category: 'icon',
  colorable: true,
  name: 'website',
  svg: websiteSvg,
};
